import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { createPaymentSettlementCall, getPaymentSettlementCall } from "../../api/api";
import { Pagination } from "@mui/material";
import getPaymentSettlementTableData from "./data/table_data";
import { CheckPermissionRender } from "helpers/checkPermission";
import permissions from "../../config/permissions";
import MDButton from "components/MDButton";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";

const limit = 8;

function PaymentSettlement() {
  const [state, setState] = useState({
    columns: [],
    rows: [],
    page: 1,
    totalPages: 1,
  });

  const isMobile = useIsMobile();

  const getPaymentSettlements = async ({ page }) => {
    const response = await getPaymentSettlementCall({ page, limit });
    if (response) {
      const { page } = response;
      const { columns, rows } = getPaymentSettlementTableData(response.data, reloadPage);
      setState({
        ...state,
        columns,
        rows,
        page,
        totalPages: response.total_pages,
      });
    }
  };

  const generateLatestSettlement = async () => {
    global.showConfDialog(
      "Are you sure?",
      <span>
        This action will summarize your unsettled payments as a payment settlement entry.
      </span>,
      async () => {
        const response = await createPaymentSettlementCall();
        global.showDialog("Info", response.message);
        reloadPage();
      },
      ["Confirm", "Cancel"]
    );
  };

  const reloadPage = () => {
    getPaymentSettlements({ page: 1 });
  };

  useEffect(() => {
    const { page } = state;
    getPaymentSettlements({ page });
  }, [state.page]);

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={1}
              >
                <MDTypography variant="h6" color="white">
                  Payment Settlements
                </MDTypography>
                <CheckPermissionRender
                  permissions={permissions().paymentSettlement().create().payment().create().list()}
                >
                  <MDButton
                    onClick={generateLatestSettlement}
                    variant="gradient"
                    color="dark"
                    style={{
                      width: "fit-content",
                    }}
                  >
                    generate latest settlement
                  </MDButton>
                </CheckPermissionRender>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                <Pagination
                  style={{
                    justifySelf: "right",
                    margin: 10,
                  }}
                  variant="outlined"
                  shape="rounded"
                  count={state.totalPages}
                  page={state.page}
                  onChange={(e, page) => {
                    setState({ ...state, page });
                  }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default PaymentSettlement;
